import React from 'react';
import {
  Dialog, DialogContent, Box, Typography, Button, Grid,
} from '@mui/material';
import HealthAndSafetyIcon from '@mui/icons-material/HealthAndSafety';
import HotelIcon from '@mui/icons-material/Hotel';
import SecurityIcon from '@mui/icons-material/Security';
import GroupIcon from '@mui/icons-material/Group';
import PaymentsIcon from '@mui/icons-material/Payments';
import RoomServiceIcon from '@mui/icons-material/RoomService';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import AirportShuttleIcon from '@mui/icons-material/AirportShuttle';
import FlightIcon from '@mui/icons-material/Flight';
import StarIcon from '@mui/icons-material/Star';
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import colors from '../../../../config/colors';
import { useSelector } from 'react-redux';

const ULTRA_PDF_URL = 'https://www.arssenasa.gob.do/wp-content/uploads/2026/08/Brochure_Digital_Ultra.pdf';

const beneficiosUltra = [
  { icon: <HealthAndSafetyIcon sx={{ fontSize: 20, color: '#fff' }} />, label: 'Cobertura ampliada del PDSS', sub: 'Más de 800 coberturas adicionales al PDSS.' },
  { icon: <HotelIcon sx={{ fontSize: 20, color: '#fff' }} />, label: 'Hospitalización al 100%', sub: 'Al 100% sin límite por año.' },
  { icon: <SecurityIcon sx={{ fontSize: 20, color: '#fff' }} />, label: 'Protección 4M alto costo', sub: 'Hasta RD$4,000,000 para alto costo.' },
  { icon: <GroupIcon sx={{ fontSize: 20, color: '#fff' }} />, label: 'Prestadores ULTRA', sub: 'Red Ultra.' },
  { icon: <PaymentsIcon sx={{ fontSize: 20, color: '#fff' }} />, label: 'Reembolso ágil', sub: 'Hasta 90% fuera de la red.' },
  { icon: <RoomServiceIcon sx={{ fontSize: 20, color: '#fff' }} />, label: 'Atención Concierge', sub: 'Servicio Concierge.' },
  { icon: <TrendingUpIcon sx={{ fontSize: 20, color: '#fff' }} />, label: 'Excelente valor', sub: 'Excelente relación cobertura-precio.' },
];

const beneficiosComplementarios = [
  { icon: <AirportShuttleIcon sx={{ fontSize: 20, color: '#fff' }} />, label: 'Ambulancia aérea y terrestre' },
  { icon: <FlightIcon sx={{ fontSize: 20, color: '#fff' }} />, label: 'Plan de repatriación' },
  { icon: <StarIcon sx={{ fontSize: 20, color: '#fff' }} />, label: 'Últimos gastos' },
  { icon: <LocalHospitalIcon sx={{ fontSize: 20, color: '#fff' }} />, label: 'Plan odontológico' },
  { icon: <AddCircleOutlineIcon sx={{ fontSize: 20, color: '#fff' }} />, label: 'Entre otros' },
];

const UltraWelcomeModal = ({ open, onClose, nombre }) => {
  const ultraDarkMode = useSelector((state) => state.afiliado.infoAfiliado.ultraDarkMode);
  const isDark = ultraDarkMode;

  const bg = isDark
    ? `linear-gradient(170deg, ${colors.ultraBlack} 0%, ${colors.ultraMid} 60%, #1e1e1e 100%)`
    : '#ffffff';
  const titleColor = isDark ? '#ececec' : '#0d0d0d';
  const subtitleColor = isDark ? 'rgba(255,255,255,0.5)' : '#6b7280';
  const benefitTitleColor = isDark ? '#e0e0e0' : '#0d0d0d';
  const benefitSubColor = isDark ? 'rgba(255,255,255,0.4)' : '#6b7280';
  const sectionTitleColor = isDark ? '#ececec' : '#0d0d0d';
  const sectionSubColor = isDark ? 'rgba(255,255,255,0.4)' : '#6b7280';
  const dividerColor = isDark ? 'rgba(255,255,255,0.07)' : 'rgba(0,0,0,0.08)';
  const iconBg = isDark ? '#1c1c1e' : '#1c1c1e';

  const iconBoxSx = {
    width: 40, height: 40, borderRadius: '10px',
    background: iconBg,
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    flexShrink: 0,
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          background: bg,
          borderRadius: '16px',
          overflow: 'hidden',
          boxShadow: isDark ? '0 32px 80px rgba(0,0,0,0.85)' : '0 16px 48px rgba(0,0,0,0.14)',
          border: isDark ? 'none' : `1px solid rgba(0,0,0,0.08)`,
        },
      }}
    >
      <DialogContent sx={{ p: 0 }}>

        {/* Hero logo block */}
        <Box sx={{
          pt: 3.5, pb: 2,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
        }}>
          <img
            src={isDark ? '/Ultra_PNG/SeNaSa_Ultra_Logo-04.png' : '/Ultra_PNG/SeNaSa_Ultra_Logo-01.png'}
            alt="SeNaSa Ultra"
            style={{ width: '52%', maxWidth: 240, height: 'auto' }}
          />
        </Box>

        {/* Title + subtitle */}
        <Box sx={{ px: 3, pt: 2.5, pb: 2 }}>
          <Typography sx={{ color: titleColor, fontSize: { xs: 18, md: 20 }, fontWeight: 800, lineHeight: 1.25, mb: 0.8 }}>
            ¡Bienvenido al Plan Ultra!
          </Typography>
          <Typography sx={{ color: subtitleColor, fontSize: 13, lineHeight: 1.6 }}>
            Desde hoy cuentas con una experiencia renovada y coberturas pensadas para llevar tu salud al siguiente nivel.
          </Typography>
        </Box>

        <Box sx={{ height: '1px', background: dividerColor, mx: 3 }} />

        {/* Beneficios Ultra — 2 columns on md+ */}
        <Box sx={{ px: 3, pt: 2, pb: 1 }}>
          <Typography sx={{ color: sectionTitleColor, fontSize: 14, fontWeight: 700, mb: 0.4 }}>
            Beneficios Ultra
          </Typography>
          <Typography sx={{ color: sectionSubColor, fontSize: 12, mb: 1.5 }}>
            Estos son los beneficios adicionales que incluye tu Plan Ultra.
          </Typography>
          <Grid container spacing={2}>
            {beneficiosUltra.map((b, i) => (
              <Grid item xs={12} sm={6} key={i}>
                <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5, py: 0.5 }}>
                  <Box sx={iconBoxSx}>{b.icon}</Box>
                  <Box>
                    <Typography sx={{ color: benefitTitleColor, fontSize: 13, fontWeight: 700, lineHeight: 1.3 }}>
                      {b.label}
                    </Typography>
                    <Typography sx={{ color: benefitSubColor, fontSize: 11.5, lineHeight: 1.5, mt: 0.3 }}>
                      {b.sub}
                    </Typography>
                  </Box>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Box>

        <Box sx={{ height: '1px', background: dividerColor, mx: 3, mt: 2 }} />

        {/* Beneficios complementarios — 2 columns on md+ */}
        <Box sx={{ px: 3, pt: 2, pb: 1 }}>
          <Typography sx={{ color: sectionTitleColor, fontSize: 14, fontWeight: 700, mb: 0.4 }}>
            Beneficios complementarios
          </Typography>
          <Typography sx={{ color: sectionSubColor, fontSize: 12, mb: 1.5 }}>
            Protección adicional para brindarte respaldo y tranquilidad cuando más lo necesitas.
          </Typography>
          <Grid container spacing={1.5}>
            {beneficiosComplementarios.map((b, i) => (
              <Grid item xs={12} sm={6} key={i}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, py: 0.4 }}>
                  <Box sx={iconBoxSx}>{b.icon}</Box>
                  <Typography sx={{ color: benefitTitleColor, fontSize: 13, fontWeight: 600, lineHeight: 1.3 }}>
                    {b.label}
                  </Typography>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Box>

        {/* CTA buttons */}
        <Box sx={{ px: 3, pt: 2, pb: 3, display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 1.5, borderTop: `1px solid ${isDark ? 'rgba(255,255,255,0.06)' : 'rgba(0,0,0,0.07)'}`, mt: 2 }}>
          <Button
            onClick={onClose}
            disableRipple
            disableElevation
            sx={{
              color: subtitleColor,
              fontSize: 13,
              fontWeight: 500,
              textTransform: 'none',
              background: 'transparent',
              px: 1.5,
              '&:hover': { background: 'transparent' },
            }}
          >
            Ahora no
          </Button>
          <Button
            variant="contained"
            disableRipple
            disableElevation
            onClick={() => window.open(ULTRA_PDF_URL, '_blank', 'noopener,noreferrer')}
            style={{ backgroundColor: isDark ? colors.ultraAccent : colors.ulCardDark, color: 'white', fontFamily: 'Montserrat', fontWeight: 'bold', textTransform: 'none', height: 48, borderRadius: 8, fontSize: 15, minWidth: 170, boxShadow: 'none', paddingLeft: 28, paddingRight: 28, letterSpacing: 0.3 }}
          >
            Explorar Ultra
          </Button>
        </Box>

      </DialogContent>
    </Dialog>
  );
};

export default UltraWelcomeModal;
